import { toMajorUnits } from 'helpers/currency-symbol';
import {
  getRejectedRetailRateRequestTooltipKey,
  isRetailRateRequestPending,
  isRetailRateRequestRejected,
} from 'features/ManageServices/Components/ServicePricingSection/pricingStatusStepper.helpers';

export const BOOKABLE_STATUS_ICON_TYPES = {
  GREEN_DOT: 'green-dot',
  GREY_DOT: 'grey-dot',
  PENDING: 'pending',
  ACTION_ALERT: 'action-alert',
};

const getMoneyInMajorUnits = (moneyItem, fallbackCurrencyCode) => {
  if (!moneyItem) return null;

  const currencyUnits = moneyItem.currencyUnits ?? moneyItem.currency_units;
  const currencyCode = moneyItem.currencyCode ?? moneyItem.currency_code ?? fallbackCurrencyCode;

  if (currencyUnits === null || currencyUnits === undefined || currencyUnits === '') {
    return null;
  }

  const numericUnits = Number(currencyUnits);

  if (Number.isNaN(numericUnits) || !currencyCode) return null;

  return toMajorUnits(currencyCode, numericUnits);
};

export const getVenueClassPayoutRate = (venueClass = {}, fallbackCurrencyCode) => {
  const minimumPayout = venueClass.payout?.minimumPayout ?? venueClass.payout?.minimum_payout;

  return getMoneyInMajorUnits(minimumPayout, fallbackCurrencyCode);
};

export function getIntegratedBookableStatusDisplay(venueClass = {}) {
  const { disabled, retailRateRequest } = venueClass;

  if (disabled) {
    return {
      messageKey: 'disabled',
      iconType: BOOKABLE_STATUS_ICON_TYPES.GREY_DOT,
      tooltipMessageKey: null,
    };
  }

  if (isRetailRateRequestPending(retailRateRequest)) {
    return {
      messageKey: 'pendingReview',
      iconType: BOOKABLE_STATUS_ICON_TYPES.PENDING,
      tooltipMessageKey: 'pendingReviewTooltip',
    };
  }

  if (isRetailRateRequestRejected(retailRateRequest)) {
    return {
      messageKey: 'actionRequired',
      iconType: BOOKABLE_STATUS_ICON_TYPES.ACTION_ALERT,
      tooltipMessageKey: getRejectedRetailRateRequestTooltipKey(retailRateRequest),
    };
  }

  return {
    messageKey: 'enabled',
    iconType: BOOKABLE_STATUS_ICON_TYPES.GREEN_DOT,
    tooltipMessageKey: null,
  };
}
